import React from 'react'
import Select from 'react-select'

export default ({
  value,
  onChange,
  onBlur,
  ...props
}) => (
  <Select
    {...props}
    value={value || ''}
    onBlur={() => {}}
    onChange={(option, items) => onChange((option || {}).value)}
  />
)



// WEBPACK FOOTER //
// ./src/components/forms/redux-single-select.js